<ng-container [formGroup]="warehouse">
  <div class="card-body">
    <h2>Job Site Name</h2>
    <div class="form-row" >
      <div class="form-group col-12">
        <label for="name" class="custom_label"> Name *</label>
        <input type="text" #htmlInputElement id="name" formControlName="name" class="form-control" placeholder=" Name" name="name">
        <app-validation-error [formGroup]="warehouse" [controlName]="'name'"></app-validation-error>
      </div>
      <div class="form-group col-12">
        <label for="email" class="custom_label"> Email </label>
        <input type="email" id="email" formControlName="email" class="form-control" placeholder=" Email" name="email">
        <app-validation-error [formGroup]="warehouse" [controlName]="'email'"></app-validation-error>
      </div>
      <div class="form-group col-12">
        <label for="phone" class="custom_label"> Phone Number </label>
        <input type="tel" id="phone" formControlName="phone" phoneMask class="form-control" placeholder=" Phone Number" name="phone">
        <app-validation-error [formGroup]="warehouse" [controlName]="'phone'"></app-validation-error>
      </div>
<!--      <div class="form-group col-12">-->
<!--        <label for="fax" class="custom_label"> Fax *</label>-->
<!--        <input type="text" id="fax" formControlName="fax" class="form-control" placeholder="Warehouse Fax" name="fax">-->
<!--        <app-validation-error [formGroup]="warehouse" [controlName]="'fax'"></app-validation-error>-->
<!--      </div>-->
    </div>
  </div>
</ng-container>
